import * as React from 'react';

import { LinkListItem, PRODUCTION_FLAG, } from '../../index';

export interface Concept {
  displayName: string;
  id: number;
  level: number;
  name: string;
  parent_id: number | null;
  uid: string;
}

export interface ConceptsData {
  [key: string]: Concept[];
}

export interface ConceptsState {
  data: ConceptsData;
  hasreceiveddata: boolean;
}

interface ConceptsProps {
  concepts: ConceptsState;
  containerClassName?: string;
  excludeResponses?: boolean;
  includeNewConceptForm?: boolean;
  onSubmitNewConcept?: (conceptName: string) => void;
  renderAsLinks?: boolean;
  fillInTheBlank?: boolean;
}

export const Concepts = ({ onSubmitNewConcept, concepts, containerClassName, excludeResponses=false, includeNewConceptForm, renderAsLinks=true, fillInTheBlank, questions, }) => {
  const newConceptNameRef = React.createRef()

  const submitNewConcept = () => {
    if (newConceptNameRef.current && onSubmitNewConcept) {
      const conceptName = newConceptNameRef.current.value;
      if (conceptName) {
        onSubmitNewConcept(conceptName);
        newConceptNameRef.current.value = '';
      }
    }
  };

  const renderConcepts = () => {
    const { data } = concepts;
    const dataRow = data['0'];

    if (!dataRow) {
      return null;
    }

    const sortedConcepts = [...dataRow].sort((a, b) =>
      a.displayName.localeCompare(b.displayName)
    );

    if (questions) {
      return (
        <table>
          <thead>
            <tr>
              <th>Writing Concept</th>
              <th>Number of {fillInTheBlank ? 'FITB' : ''} Questions</th>
            </tr>
          </thead>
          <tbody>
            {sortedConcepts.map((concept) => {
              return (
                <tr key={concept.uid}>
                  <td><a href={`${window.location.href}/${concept.uid}`}>{concept.displayName}</a></td>
                  <td>{Object.values(questions).filter(q =>
                    (q.concept_uid === concept.uid || q.conceptID === concept.uid)
                    && q.flag === PRODUCTION_FLAG).length}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      )
    }

    if (!renderAsLinks) {
      return (
        <ul className="menu-list">
          {sortedConcepts.map((concept) => (
            <li key={concept.uid}>{concept.displayName}</li>
          ))}
        </ul>
      )
    }

    return (
      <ul className="menu-list">
        {sortedConcepts.map((concept) => (
          <LinkListItem
            activeClassName="is-active"
            basePath="concepts"
            excludeResponses={excludeResponses}
            itemKey={concept.uid}
            key={concept.uid}
            text={concept.displayName}
          />
        ))}
      </ul>
    )
  };

  const renderNewConceptForm = () => {
    if (!includeNewConceptForm) {
      return null;
    }

    return (
      <div className="new-concept-form" style={{ marginTop: '1rem' }}>
        <div className="field has-addons">
          <div className="control is-expanded">
            <input
              aria-label="New concept name"
              className="input"
              placeholder="New concept name"
              ref={newConceptNameRef}
              type="text"
            />
          </div>
          <div className="control">
            <button
              className="button is-primary"
              onClick={submitNewConcept}
              type="button"
            >
              Add Concept
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <section className="tool-concepts">
      <div className={containerClassName || 'container'}>
        <h1>{fillInTheBlank ? 'Fill in the Blank Concepts' : 'Concepts'}</h1>
        {renderConcepts()}
        {renderNewConceptForm()}
      </div>
    </section>
  );
}
